var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAthenaTransIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6656 3.86573V1.37953C11.6656 1.16077 11.5787 0.950968 11.424 0.796279C11.2694 0.641591 11.0596 0.554688 10.8408 0.554688H1.76747C1.54871 0.554688 1.33891 0.641591 1.18422 0.796279C1.02953 0.950968 0.942627 1.16077 0.942627 1.37953V14.5771C0.942627 14.7958 1.02953 15.0056 1.18422 15.1603C1.33891 15.315 1.54871 15.4019 1.76747 15.4019H10.8408C11.0596 15.4019 11.2694 15.315 11.424 15.1603C11.5787 15.0056 11.6656 14.7958 11.6656 14.5771V12.5242H10.8408V14.5771H1.76747V1.37953H10.8408V3.86573H11.6656Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0163 5.50376H6.30451V3.85406L3.00513 5.91618L6.30451 7.9783V6.32861H10.0163V5.50376Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1413 9.03175L10.8419 6.96964V8.61933H7.13013V9.44418H10.8419V11.0939L14.1413 9.03175Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthenaTransIcon);
export default __webpack_public_path__ + "static/media/athena-trans-icon.43b8ab0063b04622a3c500bd1801f023.svg";
export { ForwardRef as ReactComponent };